<template>
  <section class="_menu-section-style">
    <form-section label="Itens" v-model="isExpanded.itens">
      <section v-if="loadingLogos" class="text-center py-3">
        <v-progress-circular indeterminate size="40" color="primary"/>
      </section>

      <section v-if="logos && logos.length > 0 && isItensExpandedMounted">
        <div v-for="type in logos" :key="type.codigo">
          <Expansion v-model="itensExpanded[type.codigo]" :verticalExpansion="false">
            <template slot="default">
              <div class="options-row" @click.stop="onToggleOptionRow(type.codigo)">
                <expanded-icon :isExpanded="isExpandedIcon(type.codigo)"/>
                <Checkbox 
                  v-model="selectedSection.items" 
                  :v="getValue(type)"
                  :id="type.codigo" 
                  :label="type.nome"
                  @change="(event) => { onChangeCheckBox(type.codigo, event) }"
                />        
              </div>      
            </template>

            <template slot="expanded">
              <div v-if="getCustomFields(type.codigo)" class="pt-3 pb-5 px-2">
                <Texts 
                  v-if="!selectedSection.idLayout"
                  textType="title"
                  :sectionType="selectedSection.type" 
                  :selectedSection="getCustomFields(type.codigo).settings" 
                  :hide="['alignment', 'content']"
                />
                <v-row no-gutters>
                  <v-col cols="6" class="_pt _pr-">
                    <Select 
                      label="Logo"
                      v-model="getCustomFields(type.codigo).tamanho" 
                      item-text="text"
                      item-value="value"
                      :items="sizeOptions"
                      :showBorder="true"
                    />                
                  </v-col>

                  <v-col cols="6" class="_pt _pl-">
                    <Select 
                      label="Colunas"
                      v-model="getCustomFields(type.codigo).column" 
                      :items="columnsOptions"
                      :showBorder="true"
                    />
                  </v-col>
                </v-row>
              </div>                 
            </template>
          </Expansion>          
        </div>                
      </section>

      <section v-if="!loadingLogos && logos.length === 0">
        Nenhuma logomarca cadastrada.
      </section>      
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        :minValueForNumber="160"
        @update="onUpdateBackground"
      />
      <template slot="noContent"><isEmpty/></template>
    </form-section>    

  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseObject } from '../../../schemas'
import { LOGOS_ITEM_OPTION } from '../../../schemas/sections'
import isEmpty from './isEmpty.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Background from '../forms/formsV2/Background.vue'
import FormSection from '../../_v2/utils/FormSection.vue'
import Checkbox from '../../_v2/ui/Checkbox/Checkbox.vue'
import Select from '../../_v2/ui/Select.vue'
import Expansion from '../../_v2/ui/Expansion.vue'
import ExpandedIcon from '../../_v2/utils/ExpandedIcon.vue'

export default {
  name: 'LogosSection',
  components: { 
    FormSection, 
    Texts, 
    Background, 
    isEmpty,
    Checkbox,
    Select,
    Expansion,
    ExpandedIcon
  },  
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },
  computed: {
    ...mapGetters(['logos', 'loadingLogos'])
  },

  data: () => ({
    isExpanded: {itens: true, bg: true},
    itensExpanded: {},
    isItensExpandedMounted: false,
    sizeOptions: [{value: 'P', text: 'Pequeno'}, {value: 'M', text: 'Médio'}, {value: 'G', text: 'Grande'}], 
    columnsOptions: [2, 3, 4, 6],
  }),

  mounted () {
    this.getExpandedItens()
  },

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    getValue (logo) {
      const getCustomStyle = (property) => {
        const actualConfig = this.selectedSection.items.find(item => item.codigo === logo.codigo)
        if (!actualConfig) return null

        return actualConfig[property]
      }

      const getColumnSize = (opt) => {
        const amountLogos = opt.logos.length
        if (amountLogos >= 5) return 2
        if (amountLogos === 4) return 3
        if (amountLogos === 3) return 4
        return 6
      }      

      const target = {
        codigo: logo.codigo,
        nome: logo.nome,
        column: getCustomStyle('column') || getColumnSize(logo),
        tamanho: getCustomStyle('tamanho') || logo.tamanho,
        settings: getCustomStyle('settings') || {
          title: {
            color: "",
            content: logo.nome,
            font: "",
            "font-size": '',
            'font-style': '',
            weight: ''
          }
        }
      }

      return parseObject({schema: LOGOS_ITEM_OPTION(), target: target})
    },

    getCustomFields (codigo) {
      const logo = this.selectedSection.items.find(logo => logo.codigo === codigo)
      return logo
    },

    getExpandedItens () {
      if (this.logos && this.logos.length > 0) {
        this.logos.forEach(logo => {
          // const checkIsSelected = this.getCustomFields(logo.codigo)
          this.itensExpanded[logo.codigo] = false
        })

        const checkSize = Object.keys(this.itensExpanded)
        if (checkSize.length === 0) this.isItensExpandedMounted = false
        else return this.isItensExpandedMounted = true        
      }
    },

    isExpandedIcon (codigo) {
      if (this.itensExpanded[codigo] && this.getCustomFields(codigo)) return true
      else return false
    },

    onToggleOptionRow (codigo) {
      const isActive = this.getCustomFields(codigo)
      if (!isActive) return

      if (this.itensExpanded[codigo] === true) this.itensExpanded[codigo] = false
      else this.itensExpanded[codigo] = true
      this.$forceUpdate()
    },

    async onChangeCheckBox (codigo, event) {
      this.itensExpanded[codigo] = event.target.checked
    }    
  },

  watch: {
    logos: {
      deep: true,
      handler (v) {
        this.getExpandedItens()
      }
    }
  }      
}
</script>

<style scoped>
.options-row {
  display: flex;
  flex: 1;
  padding: 8px 12px 8px 12px;
  margin-bottom: 4px;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  transition: all 0.3s
}

.options-row:hover {
  background-color: #F6F7F7;
}
</style>